var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"slider"},[_c('div',{class:['slide slide2', _vm.slideUp]},[_c('img',{attrs:{"src":'/img/TN_BRANCO.png',"width":"400","alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }